module.exports = __webpack_public_path__ + "fonts/SpoqaHanSansNeo-Regular.8c97bfe4.ttf";